import { Tooltip, IconButton } from "@mui/material";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import MemoryIcon from "@mui/icons-material/Memory";
import AutoAwesomeIcon from "@mui/icons-material/AutoAwesome";
import EditNoteIcon from '@mui/icons-material/EditNote';
import { Chip, Stack } from "@mui/material";
import { DocumentContentOrigin } from "../../documentsApi";

const iconBtnSx = { p: 0.25, "&:hover": { background: "transparent", opacity: 1 } };
const iconSx = { fontSize: 18, opacity: 0.8 };

const tinyBtnSx = { p: 0.25, "&:hover": { background: "transparent" } };
const tinyIconSx = (t: any) => ({ fontSize: 20 });

export const DocumentOriginIcon: React.FC<{ origin: "SYSTEM" | "AI" | "MANUAL" }> = ({ origin }) => {
    if (origin === "SYSTEM") {
        return (
            <Tooltip title="_System (generowane automatycznie)">
                <IconButton size="small" sx={tinyBtnSx} aria-label="System">
                    <MemoryIcon sx={tinyIconSx} color="warning" />
                </IconButton>
            </Tooltip>
        );
    }
    if (origin === "AI") {
        return (
            <Tooltip title="_AI (wygenerowane przez model)">
                <IconButton size="small" sx={tinyBtnSx} aria-label="AI">
                    <AutoAwesomeIcon sx={tinyIconSx} color="info" />
                </IconButton>
            </Tooltip>
        );
    }
    if (origin === "MANUAL") {
        return (
            <Tooltip title="_Ręczne (wprowadzone przez użytkownika)">
                <IconButton size="small" sx={tinyBtnSx} aria-label="Manual">
                    <EditNoteIcon sx={tinyIconSx} color="success" />
                </IconButton>
            </Tooltip>
        );
    } return null;
};


export function DqMappingOriginChip({
    origin
}: {
    origin: DocumentContentOrigin | undefined;
}) {
    const key = (origin ?? "").toUpperCase() as DocumentContentOrigin;

    let chip = <Chip size="small" label="Unknown" variant="outlined" />;

    switch (key) {
        case "SYSTEM":
            chip = (
                <Chip
                    size="small"
                    icon={<MemoryIcon fontSize="small" />}
                    label="System"
                    color="primary"
                    variant="filled"
                />
            );
            break;
        case "AI":
            chip = (
                <Chip
                    size="small"
                    icon={<AutoAwesomeIcon fontSize="small" />}
                    label="AI"
                    color="info"
                    variant="filled"
                />
            );
            break;
        case "MANUAL":
            chip = (
                <Chip
                    size="small"
                    icon={<EditNoteIcon fontSize="small" />}
                    label="Manual"
                    variant="outlined"
                />
            );
            break;
    }

    return (
        <Stack direction="row" spacing={1} alignItems="center">
            {chip}
        </Stack>
    );
}


type LockedIconWithTooltipProps = {
    withLabel?: boolean;
};

export const LockedIconWithTooltip: React.FC<LockedIconWithTooltipProps> = ({ withLabel = false }) => {
    return withLabel ? (
        <Tooltip title="Zablokowane do edycji">
            <Chip
                size="small"
                icon={<LockOutlinedIcon fontSize="small" />}
                label="Locked"
                variant="outlined"
            />
        </Tooltip>
    ) : (
        <Tooltip title="Zablokowane do edycji">
            <IconButton size="small" sx={iconBtnSx} aria-label="Locked">
                <LockOutlinedIcon sx={iconSx} />
            </IconButton>
        </Tooltip>
    );
};